module.exports = "/_next/static/images/search_bg_4-576845eb8c4b1cc054c0424ac312f366.jpg";